import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import ImageTerms, { IMAGE_TERMS_TITLE } from "../../components/common/ImageTerms";
import "./ImageTermsPage.css";

export default function ImageTermsPage() {
  useEffect(() => { document.title = "Termos de uso das imagens - Insecta"; }, []);
  return <main className="image-terms-page">
    <Link to="/home" className="image-terms-back">← Voltar ao Insecta</Link>
    <article><header><span>Banco de Imagens Insecta</span><h1>{IMAGE_TERMS_TITLE}</h1></header><ImageTerms /></article>
  </main>;
}
